import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { enqueueSnackbar } from "notistack";
import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import ConfirmDialog from "../../../../../../components/app/dialogs/confirmDialog/confirmDialog";
import { API } from "../../../../../../helpers/constants";
import { handleAxiosErrors } from "../../../../../../helpers/errorHandling";
import { normalizeGreek } from "../../../../../../helpers/normalizeGreek";
import useUserData from "../../../../../../hooks/user/useUserData";
import { EXHIBITOR_PROFILE } from "../../../../../../locales/components/namespaces";
import InfoGrid from "./infoGrid";

const UpdateVisitorDialogue = ({
								   formOpen,
								   setFormOpen,
								   selectedExhibition,
								   onSuccess = () => {
								   }
							   }) => {
	const { token } = useUserData()
	const { t } = useTranslation(EXHIBITOR_PROFILE)
	const [loadingSubmit, setLoadingSubmit] = useState(false)
	const [comment, setComment] = useState(formOpen.comments ? formOpen.comments : '')

	const submitComment = useCallback(() => {
		const visitorId = formOpen?.data?.id
		const comments = comment?.trim()
		if (visitorId && comments) {
			setLoadingSubmit(true)
			axios({
				url: `${API}/en/exhibition/${selectedExhibition}/checkvisitor/update/${visitorId}`,
				method: 'post',
				data: {
					Comments: comments
				},
				headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
			}).then((response) => {
				setFormOpen({
					open: false,
					data: null,
					comment: ''
				})
				setLoadingSubmit(false)
				enqueueSnackbar(t('Entry updated successfully!'), {
					variant: 'success'
				})
				onSuccess()
			}).catch((error) => {
				setLoadingSubmit(false)
				enqueueSnackbar(handleAxiosErrors(error, error?.response?.data?.errors), {
					variant: 'error',
					autoHighlight: null
				})
			})
		} else {
			setFormOpen({
				open: false,
				data: null,
				comment: ''
			})
		}
	}, [comment, formOpen?.data?.id, onSuccess, selectedExhibition, setFormOpen, t, token])
	
	const visitorInfo = useMemo(() => (formOpen.data), [formOpen.data])
	
	return (
		<ConfirmDialog
			hasBtnIcons={false}
			open={formOpen.open}
			loading={loadingSubmit}
			withLoadingButton
			handleDialog={() => setFormOpen({ open: false, data: null })}
			title={t('Visitor Details')}
			onYes={submitComment}
			onNo={() => {
				setFormOpen({ open: false, data: null })
				onSuccess()
			}}
			yesBtnText={normalizeGreek(t('Submit Comment'))}
			maxWidth={'xl'}
		>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'center',
					flexDirection: 'column',
					m: 1,
					minWidth: { xs: 300, sm: 600, md: 800, lg: 900, xl: 1000 },
				}}
			>
				{visitorInfo && Object.keys(visitorInfo).length > 0 && (
					<>
						<InfoGrid label={t('Name')}>{visitorInfo.Name}</InfoGrid>
						<InfoGrid label={t('CompanyName')}>{visitorInfo.CompanyName}</InfoGrid>
						<InfoGrid label={t('VatRegNo')}>{visitorInfo.VatRegNo}</InfoGrid>
						<InfoGrid label={t('Position')}>{visitorInfo.Position}</InfoGrid>
						<InfoGrid label={t('Email')}>{visitorInfo.Email}</InfoGrid>
						<InfoGrid label={t('CompanyMobilePhone')}>{visitorInfo.CompanyMobilePhone}</InfoGrid>
						<InfoGrid label={t('Country')}>{visitorInfo.Country}</InfoGrid>
						<InfoGrid label={t('CompanyAddress')}>{visitorInfo.CompanyAddress}</InfoGrid>
						<InfoGrid label={t('CompanyCity')}>{visitorInfo.CompanyCity}</InfoGrid>
						<InfoGrid label={t('CompanyPostalCode')}>{visitorInfo.CompanyPostalCode}</InfoGrid>
						<InfoGrid label={t('CompanyBusinessPhone')}>{visitorInfo.CompanyBusinessPhone}</InfoGrid>
						<InfoGrid label={t('CompanyWebSite')}>{visitorInfo.CompanyWebSite}</InfoGrid>
						<InfoGrid label={t('Facebook')}>{visitorInfo.Facebook}</InfoGrid>
						<InfoGrid label={t('Instagram')}>{visitorInfo.Instagram}</InfoGrid>
					</>
				)}
			</Box>
			<TextField
				id="comments"
				label={t("Comments")}
				value={comment}
				name={`comments`}
				size={"small"}
				onChange={(evt) => setComment(evt.target.value)}
				fullWidth
				multiline
				rows={6}
				variant={"filled"}
				margin="dense"
				autoFocus
				slotProps={{
					inputLabel: {
						shrink: true,
					},
				}}
			/>
		</ConfirmDialog>
	);
};

export default UpdateVisitorDialogue